import * as Neb from "nebulas" ;
import * as NebPay from 'nebpay';

const contractAddress = 'n1xk11Wm6zboVgKiyUJwiNcfDycYjkm4K4v';

// Contract addresses

// MAINNET
// TXN: b67836a420bfb3ba040cfabb140b267c76d7f65cae3a77458d26b35cb008511a
// ALPHA_v0.1 - n1xk11Wm6zboVgKiyUJwiNcfDycYjkm4K4v

// TESTNET
// Mostly unusable ...

const nebPay = new NebPay();
const neb = new Neb.Neb();
const api = neb.api;

// Endpoints
// Mainnet: https://mainnet.nebulas.io
// Testnet: https://testnet.nebulas.io
// Local: http://localhost:8685

neb.setRequest(new Neb.HttpRequest("https://mainnet.nebulas.io"));
// neb.setRequest(new Neb.HttpRequest("http://localhost:8685"));

export { contractAddress, neb, nebPay, api };


// WEBPACK FOOTER //
// ./src/util/nebulas.js